import { useQuery } from '@tanstack/react-query'
import { api, parseDataString, type TravelTimeLink } from '@/lib/api'

export function useTravelTime(project: string | null) {
  return useQuery({
    queryKey: ['travelTime', project],
    queryFn: async (): Promise<TravelTimeLink[]> => {
      const result = await api.getGraphData(project!)
      return parseDataString(result.data, result.links ?? [])
    },
    enabled: !!project,
    refetchInterval: 30000,
  })
}
